import * as React from 'react';
import { routes } from '../../../../config/routes';
import { Logo } from '../../../../components/app/logo/logo';
import { PortfolioSwitcher } from '../../../../components/app/portfolio/switcher/portfolio-switcher';

import { NavigationMobile } from '../../navigation/mobile/navigation-mobile';
import { AccountBox } from '../../account-box/account-box';

export const HeaderMobile: React.FC = () => {
    return (
        <div className="flex items-center justify-between border-b border-border bg-surface px-small py-vsmall md:px-medium">
            <div className="flex items-center gap-xsmall">
                <Logo href={routes.app.index} inApp />
                <div className="relative h-auto w-[0.1rem] self-stretch bg-border" />
                <PortfolioSwitcher />
            </div>
            <NavigationMobile />
            <AccountBox />
        </div>
    );
};
